import React from 'react';

interface UsernameScreenProps {
  username: string;
  setUsername: (username: string) => void;
  experienceLevel: string;
  setExperienceLevel: (level: string) => void;
  studyGoals: string;
  setStudyGoals: (goals: string) => void;
  handleSignUp: () => void;
  usernameError?: string;
}

const UsernameScreen: React.FC<UsernameScreenProps> = ({
  username,
  setUsername,
  experienceLevel,
  setExperienceLevel,
  studyGoals,
  setStudyGoals,
  handleSignUp,
  usernameError,
}) => {
  return (
    <div className="z-100 fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md overflow-hidden">
        <div className="bg-linear-to-r from-indigo-600 to-purple-600 py-6 px-8">
          <h2 className="text-2xl font-bold text-white">Welcome to the LSAT Gains Community</h2>
          <p className="text-indigo-100 mt-2">Choose a username to get started</p>
        </div>
        
        <div className="p-8">
          <div className="mb-6">
            <p className="text-gray-600 mb-6">
              Your username will be visible to other community members. Choose something memorable but we recommend not using your full real name.
            </p>
            
            <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="username">
              Username
            </label>
            <input 
              type="text" 
              id="username" 
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
              placeholder="Choose a username (e.g. LSATMaster2025)"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <p className="text-xs text-gray-500 mt-1">
              4-20 characters, letters, numbers, and underscores only
            </p>
          </div>
          
          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="experience">
              LSAT Experience Level
            </label>
            <select 
              id="experience" 
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
              value={experienceLevel}
              onChange={(e) => setExperienceLevel(e.target.value)}
            >
              <option value="">Select your experience level</option>
              <option value="Beginner">Beginner - Just starting out</option>
              <option value="Intermediate">Intermediate - Studied for 1-3 months</option>
              <option value="Advanced">Advanced - Studied for 3+ months</option>
              <option value="Expert">Expert - Scored 170+ or professional</option>
            </select>
          </div>
          
          <div className="mb-8">
            <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="goals">
              Your LSAT Goals (Optional)
            </label>
            <textarea 
              id="goals" 
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 resize-none h-24"
              placeholder="What are you hoping to achieve? When are you planning to take the LSAT?"
              value={studyGoals}
              onChange={(e) => setStudyGoals(e.target.value)}
            ></textarea>
          </div>
          
          <div className="flex flex-col justify-end">
            {usernameError && <p className="text-red-400 mb-2">{usernameError}</p> }
            <button 
              className={`px-6 py-2 ${
                !username || !experienceLevel
                  ? 'bg-indigo-400 cursor-not-allowed'
                  : 'bg-indigo-600 hover:bg-indigo-700'
              } text-white rounded-md transition-colors`}
              onClick={handleSignUp}
              disabled={!username || !experienceLevel}
            >
              {/* Note: Removed the check for signUpMutation.isPending and using a placeholder condition */}
              {false ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2 inline-block"></div>
                  Creating Account...
                </>
              ) : (
                'Join Community'
              )}
            </button>
            <button 
              className={`mt-4 px-6 py-2 bg-gray-300 hover:bg-gray-400 text-black rounded-md transition-colors`}
              onClick={handleSignUp}
            >Nevermind...
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsernameScreen;
